module.exports = __webpack_public_path__ + "static/media/pyv-left-click-set-right-click-finish.eac6f8b8.gif";